var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 19.504,
    viewBox: "0 0 17.998 19.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M8.2,4.82a.75.75,0,0,1,.634,1.36,7.5,7.5,0,1,0,6.337.007.75.75,0,0,1,.637-1.358A9,9,0,1,1,8.2,4.82ZM12,2.5a.75.75,0,0,1,.743.648l.007.1v7.5a.75.75,0,0,1-1.493.1l-.007-.1v-7.5A.75.75,0,0,1,12,2.5Z",
    transform: "translate(-3 -2.496)",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5fba1483080fecf0bb5b71c4cf915349.svg";
export { ForwardRef as ReactComponent };